import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import ViewModel from '@bingads-webui-campaign-legacy/auto-targets/viewmodel/specific-target';
import template from '@bingads-webui-campaign-legacy/auto-targets/template/specific-target-template.pug';
import CategoryGridView from '@bingads-webui-campaign-legacy/auto-targets/view/category-targets/category-grid';
import config from '@bingads-webui-component-legacy/config/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = options;

    this.categoryViews = {};

    this.viewmodel = new ViewModel(this.options);

    this.viewmodel.values.subscribe((newValues) => {
      this.refreshCategoryView();
      this.trigger('update', newValues);
      if (ko.isObservable(this.options.conditions)) {
        this.options.conditions(newValues);
      }
    });
    const permissions = config.get('Permissions');

    this.urlEqualsEnabled = permissions && permissions.dynamic && permissions.dynamic.DSAUrlEquals;
  }

  get events() {
    return {
      'change .specific-target-condition select': 'onOperandChange',
      'click .edit-category-icon': 'addCategoryView',
    };
  }

  render() {
    this.$el.html(template({i18n, showAND: this.urlEqualsEnabled }));
    ko.applyBindings(this.viewmodel, this.el);

    this.on('update:setting', (setting) => {
      if (!_.isEmpty(setting.DomainName)) {
        _.each(this.categoryViews, (view) => {
          view.trigger('update:setting', setting);
        });
      }

      this.viewmodel.setting(setting);
      this.viewmodel.reset();
    });

    return this;
  }

  refreshCategoryView() {
    _.each(_.keys(this.categoryViews), (uuid) => {
      if (this.$(`div[uuid='${uuid}']`).length === 0) {
        this.removeCategoryView(uuid);
      }
    });
  }

  removeCategoryView(uuid) {
    if (_.isEmpty(this.categoryViews[uuid])) {
      return;
    }
    this.categoryViews[uuid].remove();
    delete this.categoryViews[uuid];
  }

  getCategoryContainer(e) {
    let $eventTarget = $(e.currentTarget);

    return $('.category-container', $eventTarget.closest('.specific-target-condition'));
  }

  clearCategoryView(e) {
    let $container = this.getCategoryContainer(e);

    if ($container.length > 0) {
      _.each($container.children(), (child) => {
        this.removeCategoryView($(child).attr('uuid'));
      });
    }
  }

  addCategoryView(e) {
    let $container = this.getCategoryContainer(e);
    let uuid = _.uniqueId('category_view_');

    this.clearCategoryView(e);
    this.categoryViews[uuid] = new CategoryGridView({hideAddToList: true, setting: this.viewmodel.setting(), isContainerHidden: false}).render();
    this.categoryViews[uuid].$el.attr('uuid', uuid);
    $container.append(this.categoryViews[uuid].el);
    this.categoryViews[uuid].grid.gridView.on('layout:click:cell', (event, data) => {
      if (event.target && event.target.className && event.target.className.indexOf('next-level') > -1 && data.column.property === 'CategoryName' && _.last(data.model.CategoryName) === '/') {
        return;
      }
      const currentViewModel = ko.dataFor(event.target);

      currentViewModel.ArgumentOperand(data.model.CategoryName);//eslint-disable-line
      this.removeCategoryView(uuid);
    });
    this.categoryViews[uuid].on('categoryLoaded', (isCategoriesEmpty) => {
      this.viewmodel.isCategoriesEmpty(isCategoriesEmpty);
    });
  }


  onOperandChange(e) {
    if ($(e.currentTarget).val() === 'Category') {
      this.addCategoryView(e);
    } else {
      this.clearCategoryView(e);
    }
  }
}
